import React, { useState, useEffect } from "react";
import "./Guide.css";


const Guide = ({ }) => {
    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);
    const [activeTab, setActiveTab] = useState("mission");
    return (
        <section className="wrapper">
            <h2 className="heading"><i className="fa fa-house"></i> Portal Guide</h2>

            <div className='tabs'>
                <div className="left-panel">
                    <ul className='left-nav'>
                        {/* <TabNavItem title="Get Started" id="history" activeTab={activeTab} setActiveTab={setActiveTab} /> */}
                        <TabNavItem title="Home" id="mission" activeTab={activeTab} setActiveTab={setActiveTab} />
                        {/* <TabNavItem title="About Us ?" id="functions" activeTab={activeTab} setActiveTab={setActiveTab} /> */}
                        <TabNavItem title="Join Us" id="board" activeTab={activeTab} setActiveTab={setActiveTab} />
                        <TabNavItem title="Contact Us" id="shareholders" activeTab={activeTab} setActiveTab={setActiveTab} />
                        <TabNavItem title="Payment" id="payment" activeTab={activeTab} setActiveTab={setActiveTab} />
                        <TabNavItem title="Activate Account" id="structure" activeTab={activeTab} setActiveTab={setActiveTab} />
                    </ul>
                </div>
                <div className='right-panel'>
                    <TabContent id="history" activeTab={activeTab}>
                        {/* <History /> */}
                    </TabContent>
                    <TabContent id="mission" activeTab={activeTab}>
                        <MissionVisionValues />
                    </TabContent>
                    <TabContent id="functions" activeTab={activeTab}>
                        <Functions />
                    </TabContent>
                    <TabContent id="board" activeTab={activeTab}>
                        <Board />
                    </TabContent>
                    <TabContent id="shareholders" activeTab={activeTab}>
                        <Shareholders />
                    </TabContent>
                    <TabContent id="payment" activeTab={activeTab}>
                        <Subsidiaries />
                    </TabContent>
                    <TabContent id="structure" activeTab={activeTab}>
                        <OperatingStructure />
                    </TabContent>
                </div>
            </div>
            <div>
                <div style={{ height: '10rem' }} />
            </div>
        </section >
    );
};

export default Guide;

function TabNavItem({ id, title, activeTab, setActiveTab }) {
    const handleClick = () => {
        setActiveTab(id);
    };
    return (
        <li onClick={handleClick} className={activeTab === id ? "active" : ""}>
            {title}
        </li>
    )
}
function TabContent({ id, activeTab, children }) {
    return (
        activeTab === id ? <div className='TabContent'>
            {children}
        </div>
            : null
    )
}

function History() {
    return (
        <div className='history'>
            <h1>Get Started</h1>
            <p>The ProForum MMS Portal is for NDC professionals, or other qualified person, who desires to become a member of the NDC PRO-FORUM.
            </p><br />
            
            <h1>New Membership</h1>
            <p>The ProForum Membership Portal enables new members to join by completing an Online Application Form.
            </p><br />

            <h1>Existing Members</h1>
            <p>The ProForum Membership Portal enables existing members to access their information by log in to their portal.
            </p><br />

            <h1>Who We Are</h1>
            <p>We are an association of doctors, nurses, lawyers, lecturers, engineers and communicators among others within the NDC whose experiences the party can tap in cases that deserve professional advice.</p><br />

            <h1>Our Mission</h1>
            <p>The National Democratic Congress (NDC) launched the Professionals Forum on 6th March, 2018 to discuss issues of importance to the party and help to implement the recommendations of the 2016 Election Report to ensure victory for the party in 2020.</p><br />

            <h1>Our Vision</h1>
            <p>The NDC believes in the responsibility to deepen social democracy in contemporary Ghana, which mandates the state to put certain facilities in place for the citizens, especially women and children, to improve their wellbeing.</p><br />

            <h1>Membership</h1>
            <p>Membership is opened to all Ghanaians who believe in NDC ideas of Social Democracy</p><br />

        </div>
    )
}
function MissionVisionValues() {
    return (
        <div className='mission'>
            <h1>Get Started</h1>
            <p>The Proforum MMS Portal is for NDC professionals, or other qualified person, who desires to become a member of the NDC PRO-FORUM.
            </p><br />

            <h1>New Membership</h1>
            <p>The Portal enables new members to join by completing an Online Application Form.
            </p><br />

            <h1>Existing Members</h1>
            <p>The Portal enables existing members to access their information.
            </p><br />

            <h1>Membership</h1>
            <p>Membership is opened to all Ghanaians who believe in NDC ideas of Social Democracy</p><br />
            <div>
                <img src="/images/guide/home.jpg" alt="home" width={"600px"} />
            </div>
        </div>
    )
}

function Functions() {
    return (
        <div className='core-functions'>
            <h1>About Us</h1>
        </div>
    )
}
function Board() {
    return (
        <div className='board-composition'>
            <h1>Join Us</h1>
        </div>
    )
}
function Shareholders() {
    return (
        <div className='shareholders'>
            <h1> Contact Us</h1>

        </div>
    )
}

function Subsidiaries() {
    return (
        <div className='payment'>
            <h1>Payment</h1>
        </div>
 
    )
}
function OperatingStructure() {
    return (
        <div className='payment'>
            <h1>Activate Account</h1>
        </div>
 
    )
}

